import { FormattedMessage } from "react-intl";

import { StartPickingRefusalCode } from "flows/Picking/utils/startPickingRefusal";
import { IntlMessageId } from "shared/lang";
import { Button } from "ui/Button/Button";
import { Modal, ModalProps } from "ui/Modal/Modal";
import { BodyS, HeaderS } from "ui/Typography/Typography";

function getRefusalMessages(refusalCode: StartPickingRefusalCode): {
  titleId: IntlMessageId;
  descriptionId: IntlMessageId;
} {
  switch (refusalCode) {
    case "PICKING_ORDER_NO_HUB_PICKUP":
      return {
        titleId: "components.picking.start-picking-refusal-modal.title.no-hub-pickup",
        descriptionId: "components.picking.start-picking-refusal-modal.description.no-hub-pickup",
      };
    case "PICKING_ORDER_NO_LIVE_DELIVERY":
      return {
        titleId: "components.picking.start-picking-refusal-modal.title.no-live-delivery",
        descriptionId:
          "components.picking.start-picking-refusal-modal.description.no-live-delivery",
      };
  }
}

type StartPickingRefusalModalProps = {
  refusalCode: StartPickingRefusalCode;
  onClose: () => void;
} & Pick<ModalProps, "isOpen">;

export function StartPickingRefusalModal({
  isOpen = false,
  refusalCode,
  onClose,
}: StartPickingRefusalModalProps) {
  const { titleId, descriptionId } = getRefusalMessages(refusalCode);

  return (
    <Modal
      trapFocus={false}
      closeOnOverlayClick={false}
      isCentered
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Content marginX="s300">
        <Modal.Header textAlign="center" paddingX="s200">
          <HeaderS>
            <FormattedMessage id={titleId} />
          </HeaderS>
        </Modal.Header>
        <Modal.Body paddingY="0" paddingX="s200">
          <BodyS textAlign="center" color="grey.700">
            <FormattedMessage id={descriptionId} />
          </BodyS>
        </Modal.Body>
        <Modal.Footer padding="s200">
          <Button onClick={onClose} isFullWidth size="lg" data-testid="refusal-close-btn">
            <FormattedMessage id="generic.actions.got-it" />
          </Button>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
}
